import { useEffect, useState, useRef } from 'react'
import { Header, LeadsList } from '../../shared/components'
import {
  LayoutWrapper,
  NewIncomeAnslysisNoticeDiv,
  NewIncomeAnslysisNoticeText,
} from '../../shared/components/Home.styles'
import { MainLayout } from '../../shared/components/MainLayout/MainLayout'
import { Error } from '../../shared/components/Error/Error'
import { StyledCenterIcon } from '../../shared/components/Document/Document.style'
import { Loading } from '../../shared/components/Icons'
import { getLeadsList, logout } from '../../api/api'
import { configureAbly, useChannel } from '@ably-labs/react-hooks'
import { AblyApiKey } from '../../infrastructure/apikeys/apikeys'
import { IconBellWarning } from '@creditas-ui/react'
import { GlobalIcons } from '@creditas-ui/react'
import { RequireAuth } from '../../utils/requiredAuthValidation'
import alert from '../../assets/audio/alert.mp3'

const Home = () => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [leadsData, setLeadsData] = useState([])
  const [hasNewIncomeAnalysis, setHasNewIncomeAnalysis] = useState(false)
  const audio = useRef(new Audio(alert))

  configureAbly({ key: AblyApiKey })
  useChannel('home-solutions', () => {
    setHasNewIncomeAnalysis(true)
    reproduceAudio()
    showNotification()
  })

  const reproduceAudio = () => {
    audio.current.play()
  }

  const showNotification = () => {
    if (Notification.permission === 'granted') {
      new Notification('🚨 Existem novas análises de renda disponíveis!')
    }
  }

  const loadLeadListData = async () => {
    try {
      setError(false)
      setLoading(true)
      const response = await getLeadsList()
      setLeadsData(response.data)
    } catch (error) {
      setError(true)
      if (error?.response?.status === 401) {
        logout()
      }
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    loadLeadListData()

    const handlePrimeiroClique = async () => {
      document.removeEventListener('click', handlePrimeiroClique)
      audio.current.volume = 1
    }

    document.addEventListener('click', handlePrimeiroClique)

    return () => {
      document.removeEventListener('click', handlePrimeiroClique)
    }
  }, [])

  if (loading) {
    return (
      <StyledCenterIcon>
        <Loading />
      </StyledCenterIcon>
    )
  }

  if (Notification.permission !== 'denied') {
    Notification.requestPermission()
  }

  return (
    <RequireAuth navigationRoute={'/'}>
      <LayoutWrapper>
        <MainLayout>
          <Header title='GreyZone - Análise de Credito' />
          {hasNewIncomeAnalysis && (
            <NewIncomeAnslysisNoticeDiv>
              <NewIncomeAnslysisNoticeText>
                Existem novas análises de renda disponíveis. Atualize a página para visualizá-las.
              </NewIncomeAnslysisNoticeText>
              <GlobalIcons Icon={IconBellWarning} size='x_large' />
            </NewIncomeAnslysisNoticeDiv>
          )}
          {!loading && !error && (
            <>{(leadsData?.length >= 0) | (leadsData === '') && <LeadsList leads={leadsData} />}</>
          )}
          {!loading && error && <Error />}
        </MainLayout>
      </LayoutWrapper>
    </RequireAuth>
  )
}

export default Home
